import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { AppStateService } from '../app-state.service';
import { Podprogram } from '../model/podprogram';

export interface PodprogramyDialogData {
  idPodprogram: number;
  pocetSkopirovanychPoloziek: number;
}

export interface Jazyk {
  kod: string;
  oznaceny: boolean;
}


@Component({
  selector: 'app-podprogramy-copying-dialog',
  templateUrl: './podprogramy-copying-dialog.component.html',
  styleUrl: './podprogramy-copying-dialog.component.css',
  standalone: false
})
export class PodprogramyCopyingDialogComponent implements OnInit{

  idPodprogramIN: number;
  // studProgramy = ['DMd - Diskrétna matematika', 'DMde - Diskrétna matematika'];
  podprogramy = [];
  podprogramyZRegistraPole: Podprogram[] = [];
  skratkaOznacenyPodprogram: string;
  indexOznacenyPodprogram: number;
  zobrazitHelpText = false;
  searchedDataInput = '';
  oznaceniePodprogramovPole: boolean[] = [];
  indexyPodprogramov = [];
  // jazyky = ['SK', 'EN', 'FR'];
  jazykyZvolenehoPodprogramu: Jazyk[] = [];
  upozornenieText = '';

  podprogramyDotiahnute: boolean = null;

  disablovanyPotvrditButton = true;

  jazyky = {
    kod: '',
    oznaceny: false
  }

  checknuteJazykyZvolenehoPodprogramu = [];
  // pocetSkopirovanychPoloziek = 0;

  spinner = false;

  constructor(private appStateService: AppStateService,
    public dialogRef: MatDialogRef<PodprogramyCopyingDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dataMatDialog: PodprogramyDialogData,
    private translateService: TranslateService) {

  }

  ngOnInit(): void {

    this.idPodprogramIN = this.dataMatDialog.idPodprogram;

    for (let i = 0; i < this.podprogramy.length; i++) {
      this.indexyPodprogramov[i] = false;
    }

  }


  onSubmit() {
  }

  getHelpTooltipText() {
    let result = this.translateService.instant('Zadajte časť skratky alebo názvu podprogramu (aj bez diakritiky).');
    // if (this.appStateService.haikOdbor) {
    //   result = this.translateService.instant('Zadajte časť skratky alebo názvu odboru (aj bez diakritiky).');
    // }
    return result;
  }

  getSearchedDataInputPlaceholder() {
    let result = this.translateService.instant('Podprogram');
    // if (this.appStateService.haikOdbor) {
    //   result = this.translateService.instant('Odbor');
    // }
    return result;
  }

  getZmazText() {
    return this.translateService.instant('Zmazať');
  }

  onPodprogramRadioBoxChange() {

    this.disablovanyPotvrditButton = true;

    this.jazykyZvolenehoPodprogramu = [];

    // console.log('index oznaceneho riadku: ' + this.indexOznacenyStudProgram);
    // console.log('Stud. program z registra (aktualne oznaceny): '
    //   + this.studijneProgramyZRegistraPole[this.indexOznacenyStudProgram].id);


    this.appStateService.fetchJazykyFormularaPodprogramu(this.podprogramyZRegistraPole[this.indexOznacenyPodprogram].id);

    this.appStateService.jazykyPoloziekDokumentuPodprogramuDataFetched
    .subscribe((jazykyData) => {

      if (jazykyData && jazykyData.length > 0) {
        for (let index = 0; index < jazykyData.length; index++) {
          const kodJazyk = jazykyData[index];
          const jazyk: Jazyk = {
            kod: kodJazyk,
            oznaceny: true
          }
          this.jazykyZvolenehoPodprogramu[index] = jazyk;
        } {

        }
        // this.jazykyZvolenehoStudProgramu = jazykyData;
        this.disablovanyPotvrditButton = false;
      } else {
        this.upozornenieText = this.translateService.instant('pre tento podprogram neboli nájdené žiadne položky');
      }


    });

    for (let index = 0; index < this.podprogramyZRegistraPole.length; index++) {
      if (index === this.indexOznacenyPodprogram) {
        this.oznaceniePodprogramovPole[index] = true;
      } else {
        this.oznaceniePodprogramovPole[index] = false;
      }

    }
    this.oznaceniePodprogramovPole[this.indexOznacenyPodprogram] = true;
  }

  vyhladajPodprogramy(hladanyRetazec: string, myFormInvalid?: boolean) {

    // console.log('myFormInvalid: ' + myFormInvalid);
    if (myFormInvalid) {
      return;
    }

    this.spinner = true;

    this.appStateService.fetchPodprogramyZRegistraData(hladanyRetazec);

    this.appStateService.podprogramyZRegistraDataFetched
    .subscribe((data) => {

      this.spinner = false;

      if (data && data.length > 0) {
        this.podprogramyZRegistraPole = data;
        this.podprogramyDotiahnute = true;
      } else {
        this.podprogramyDotiahnute = false;
        this.podprogramyZRegistraPole = [];
      }

    });


  }

  potvrditVyberPodprogramu() {

    // ak sme nic nevybrali
    if (!this.indexOznacenyPodprogram) {
      return;
    }

    this.jazykyZvolenehoPodprogramu.forEach(jazyk => {
      if (jazyk.oznaceny) {
        this.checknuteJazykyZvolenehoPodprogramu.push(jazyk.kod);
      }
    });

    // console.log('checknute jazyky: ' + this.checknuteJazykyZvolenehoStudProgramu);

    if (this.podprogramyZRegistraPole && this.podprogramyZRegistraPole[this.indexOznacenyPodprogram]) {
      this.appStateService.kopirujPolozkyZPodprogramu(
        this.podprogramyZRegistraPole[this.indexOznacenyPodprogram].id,
        this.checknuteJazykyZvolenehoPodprogramu);
    }


  }

  getNazovDialogu() {
    return this.translateService.instant('Podprogramy, časti študijného programu');;
  }

  // validation(event) {
  //   const text = document.getElementById('searchedDataInput');
  //   if ((text as any).value === '') {
  //     event.cancel = true;
  //     alert("Enter the username and password");
  //   }

  // }

  clearSearchInput($event: MouseEvent) {
    if ($event instanceof PointerEvent) {
      if ($event.pointerType === 'mouse') {
        this.searchedDataInput = '';
      }
    }
  }

  keyPressed() {
    this.searchedDataInput = '';
  }

  overitDisablovaniePotvrditButtonu() {

      if (this.podprogramyDotiahnute && this.indexOznacenyPodprogram) {
          for (const jazyk of this.jazykyZvolenehoPodprogramu) {
            if (jazyk.oznaceny) {
              this.disablovanyPotvrditButton = false;
              return;
            }
          }
          this.disablovanyPotvrditButton = true;
      }

  }

  getHladajTooltip() {
    return this.translateService.instant("Hľadaj");
  }



}
